import React from "react";
import shipImg from "assets/img/auth/ship.gif";

const FullScreenLoader = () => {
  return (
    <div className="dark:bg-black/70 fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm">
      <img src={shipImg} alt="Loading"  className="h-64 w-64"/>
    </div>
  );
};

export default FullScreenLoader;
